import { StreamActions } from '@hotwired/turbo'
import ModalController from '../../stimulus/controllers/modal'

StreamActions.clear_modal = function () {
  const targetModal = document.querySelector('[data-controller*=modal]')

  if (!targetModal) {
    console.warn('No modals found to clear. Skipping')
    return
  }

  const modalController = window.Stimulus.getControllerForElementAndIdentifier(targetModal, 'modal') as ModalController

  if (!modalController) {
    console.warn('No modals controllers found to clear. Skipping')
    return
  }

  modalController.close()
}
